import React from 'react'

function Header() {
  return (
    <>
      <header>
        <div className='container'>
        <div class="hero-box">
                <h1>Goodbye junk food. <br /> Hello super healthy meals.</h1>
                <a href="#meals" class="btn">I’m hungry</a>
                <a href="#features" class="btn">Show me more</a>
            </div>
        </div>
      </header>
    </>
  )
}

export default Header